<template>
  <div class="news-content" :class="`type-${type}`">
    <div class="news-title">{{newsCont.noticeTitle}}</div>
    <div class="news-cont" v-html="newsCont.noticeContent"></div>
  </div>
</template>

<script>
  export default {
    name: 'News',
    data(){
      return {
      newsCont: null,
        type: ''
      }
    },
    created() {
      this.newsCont = this.$route.params.news;
      this.type = this.$route.params.type;
      if (!this.newsCont)
      this.$destroy();
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        // 确保组件实例创建后再执行 scrollTo
        vm.$nextTick(() => {
          window.scrollTo(0, 0);
        });
      });
    },
    beforeDestroy() {
      window.scrollTo(0, 0);
    },
    watch:{
      '$route': {
        handler: function (to, from) {
          // 当路由发生变化时会调用这个函数
          // to 和 from 分别代表到达的路由和离开的路由
          //console.log('Route changed from', from, 'to', to);
          // 在这里可以根据路由变化执行相应的逻辑
          if (to.name === 'home' || to.name === 'mhome') {
            this.$destroy();
          }
        },
        // 如果需要在路由变化时立即响应，可以设置immediate为true
        immediate: true,
        deep: true
      }
    }
  }
</script>

<style scoped lang="less">
.news-content{
  width: 100vw;
  height: auto;
  min-height: 100vh;

  &.type-mobile{
    background: url('https://scszsj-system.oss-cn-beijing.aliyuncs.com/pic0/newsBgV.jpg') no-repeat;
    background-size: cover;
    .news-title{
      box-sizing: border-box;
      padding-top: 1.8rem;
      width: 100%;
      font-size: .3rem;
      line-height: .46rem;
      color: #fff;
      font-weight: bold;
      text-align: center;
    }
    .news-cont{
      box-sizing: border-box;
      padding: .3rem .7rem 2.4rem;
      width: 100%;
      height: auto;
      font-size: .24rem;
      color: #fff;
      /deep/ p, /deep/ strong{
        font-size: .24rem;
        line-height: .34rem;
      }
      /deep/ p{
        text-align: left;
        text-indent: 2em;
        word-break: break-all;
      }
      /deep/ img {
        box-sizing: border-box;
        width: 100%;
        margin-top: .1rem;
        margin-left: -.48rem;
      }
    }
  }
  &.type-pc{
    background: url('https://scszsj-system.oss-cn-beijing.aliyuncs.com/pic0/newsBg.jpg') no-repeat;
    background-size: cover;
    .news-title{
      box-sizing: border-box;
      padding-top: 1rem;
      width: 100%;
      font-size: .3rem;
      line-height: .46rem;
      color: #fff;
      font-weight: bold;
      text-align: center;
    }
    .news-cont{
      box-sizing: border-box;
      padding: .3rem 3rem 2.4rem;
      width: 100%;
      height: auto;
      font-size: .24rem;
      color: #fff;
      /deep/ p, /deep/ strong{
        font-size: .24rem;
        line-height: .34rem;
      }
      /deep/ p{
        text-align: left;
        text-indent: 2em;
        word-break: break-all;
      }
      /deep/ img {
        box-sizing: border-box;
        width: 100%;
        margin-top: .1rem;
        margin-left: -.48rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/news.vue